var map = {
	"../pages/comment/comment.module": [
		171
	],
	"../pages/customer/customer.module": [
		328,
		3
	],
	"../pages/dashboard/dashboard.module": [
		177
	],
	"../pages/pricing/pricing.module": [
		329,
		2
	],
	"../pages/qrcode/qrcode.module": [
		184
	],
	"../pages/rating-collectors/rating-collectors.module": [
		185
	],
	"../pages/rating-factor/rating-factor.module": [
		330,
		1
	],
	"../pages/rating/rating.module": [
		331,
		0
	],
	"../pages/settings/settings.module": [
		186
	],
	"../pages/support/support.module": [
		187
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 170;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 170
// module chunks = 4